import React from "react";

import "./About.css";

const Help = () => {
  const bgUrl = `${import.meta.env.BASE_URL}riva.jpg`;
  const backgroundStyle = {
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(${bgUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "100%",
    color: "white",
  };

  return (
    <>
      <div className="top-bar"></div>
      <section lang="en" className="main-content">
        <div className="flex-pane" style={backgroundStyle}>
          <div className="overlay"></div>
          <div className="about">
            <h2>Riva BPM </h2>
            <p>
              Riva BPM is an approach to business process management developed
              by Martyn A. Ould that is based on the idea that business process
              architectures are best described as a set of business entities and
              the dynamic relationships between them. The print book is no
              longer in print but copies are available from Amazon at:
            </p>
            <p>
              <a href="https://www.amazon.co.uk/Business-Process-Management-Rigorous-Approach/dp/1902505603/ref=sr_1_1?crid=F9QKTGUR9SG2&dib=eyJ2IjoiMSJ9.k2DvMYFPw1yaMcQRjVuyoYQwu2NZ-MaGhZwiKOCbq80Kfe-5l1akJ1ReJmPBRs9kWJF3hua__G1ca5c2pAiOBEE1nrh0tYR1HM3CuEmNahiWU9TUTuVmvfetbqFgT9G9rn-jKjT6rZCdEERvsMg8_uBg5a58mG0Gt5qcaMBtUFCkbGM49p_JJDbLHUu2myAyh8f5W4g1GQirepzhl8CJsex88d92c4jirXzx1SiTqgQ.ihpR6rkrejeEyNwLhfz-t043xZPuU8BSRb-blBpx0cY&dib_tag=se&keywords=martyn+ould&nsdOptOutParam=true&qid=1734626931&s=books&sprefix=martyn+ould%2Cstripbooks%2C94&sr=1-1">
                Business Process Management - a rigorous approach
              </a>
            </p>
            <p>Other sellers may/probably have better prices.</p>
            <p>A full pdf version is available free at:</p>
            <p>
              <a href="http://www.veniceconsulting.co.uk/BPMARAdistributionfolder/BPMARAroot.htm">
                Venice Consulting: Business Process Management - a rigorous
                approach
              </a>
            </p>
            <p>
              and general resources are also available from Martyn&apos;s
              website at:
            </p>
            <p>
              <a href="http://www.veniceconsulting.co.uk/veniceresources.htm">
                Venice Consulting
              </a>
            </p>
            <p>
              The Role Activity Diagram (RAD) has been developed by Martyn A.
              Ould as a way of describing business processes that are inherently
              concurrent and asynchronous. It has been somewhat overtaken by the
              BPMN standard but is still a useful tool for describing business
              processes. Personally I find it easier to use than BPMN, but that
              is a matter of taste. In general I find notations with a small set
              of symbols end up being more expressive than those with a large
              set of symbols (ahem - BPMN).
            </p>
            <hr />
            <p>
              This application is very much a work in progress. Don&apos;t
              expect it to be perfect or even finished. If you find bugs or have
              suggestions for improvements please contact me on the main contact
              page.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Help;
